export const about = [
  <>
    A kronobiológia a biológiai ritmusok tudománya, amely az emberi élet
    ciklikusságát és annak hatását vizsgálja a{" "}
    <b>fizikai, érzelmi és szellemi</b> működésre. A modern pszichológia,
    biológia, valamint az ősi asztrológiai hagyományok <b>ötvözéséből</b>{" "}
    született meg. A kronobiológiai sorsanalízis az{" "}
    <b>élet ritmusait és jellemzőit</b> vizsgálja annak érdekében, hogy segítsen
    az <b>egyéni képességek</b> felismerésében, a <b>kapcsolati dinamika</b>{" "}
    megértésében, valamint a <b>fejlődési utak feltárásában</b>.
  </>,
];
export const basicsBefore = (
  <>
    A kronobiológia szerint az emberi élet ritmusait{" "}
    <b>három fő biológiai ciklus</b> határozza meg:
  </>
);
export const basicsAfter = (
  <>
    Ezek a ciklusok az ember születésétől kezdve hatnak, és állandó hullámzásban
    vannak, ami <b>befolyásolja teljesítményünket és viselkedésünket</b>{" "}
    különböző időpontokban.
  </>
);
export const basics = [
  <>
    <b>Fizikai ciklus</b> (23 nap): Az{" "}
    <b>életerő, testi állóképesség, energia</b>, dinamizmus szintjét
    szabályozza.
  </>,
  <>
    <b>Érzelmi ciklus</b> (28 nap): A{" "}
    <b>hangulat, az érzelmi stabilitás és az empátia</b> alakulását
    befolyásolja.
  </>,
  <>
    <b>Szellemi ciklus</b> (33 nap): Az <b>intellektuális</b> képességeket,{" "}
    <b>kreativitást</b> és a <b>logikai gondolkodást</b> szabja meg.
  </>,
];
export const benefits = [
  <>
    <b>Önismeret fejlesztése:</b> Az egyén jobban megérti saját erősségeit és
    gyengeségeit.
  </>,
  <>
    <b>Kapcsolati dinamika:</b> A kronobiológia segít megérteni, hogy két ember
    (pl. párkapcsolat, munkatársak, családtagok) energetikai profilja hogyan hat
    egymásra.
  </>,
  <>
    <b>Pályaválasztás és karriertervezés:</b> A képességek felismerése
    lehetőséget ad a megfelelő munkaterület kiválasztására.
  </>,
  <>
    <b>Egészségmegőrzés:</b> A fizikai és érzelmi ciklusok ismeretében
    hatékonyabb pihenési és regenerációs terv alakítható ki.
  </>,
];

export const technique = (
  <>
    Egy <b>személyiségelemző módszer</b>, amely <b>nem helyettesítheti</b> a
    pszichológiai vagy biológiai vizsgálatokat.
  </>
);
